/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class CategoryItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="category-combo-item">
                <div className="category-combo-swatch" style={{backgroundColor: this.props.item.color}}></div>
                <div className="category-combo-name" alt={this.props.item.name} title={this.props.item.name}>{this.props.item.name}</div>
            </div>
        );
    }
}

CategoryItem.propTypes = {
    item: PropTypes.object
};

CategoryItem.defaultProps = {
    item: {}
};

export default CategoryItem;
